import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { Section } from 'foundations-components/transitional/components/Section';
import { List } from 'foundations-components/transitional/components/List';
import ReviewBody from 'marketplace-ui-reviews/components/ReviewBody';
import ReviewerInfo from 'marketplace-ui-reviews/components/ReviewerInfo';
import QualityDistribution from 'marketplace-ui-reviews/components/QualityDistribution';
import ReviewReplyThread from 'marketplace-ui-reviews/components/ReviewReplyThread';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import Rating from 'marketplace-ui-reviews/components/Rating';
import * as ReviewTypes from 'marketplace-ui-reviews/constants/ReviewType';
import { RatingAxes } from 'marketplace-ui-reviews/constants/RatingAxes';
// @ts-expect-error untyped dependency
import withReportModalState from './withReportModalState';

// Renders a complete review item given a review. ReviewsList iterates through
// a list of reviews and calls the Renderer to display each one
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AllReviewsRenderer({
  isCustomer,
  onReplyModalOpen,
  review,
  reviewModalOpen,
  replyModalOpen,
  reportReviewModal,
  reportReplyModal,
  reviewActionsList,
  searchTerm,
  showOriginal,
  showUntranslatedText,
  onTrackInteraction
}) {
  const {
    flexDirection,
    marginBlockEnd
  } = useResponsiveProps({
    flexDirection: {
      xs: 'column',
      sm: 'row',
      md: 'column'
    },
    marginBlockEnd: {
      sm: '400'
    }
  });
  const rating = showOriginal ? review.get('original').ratings.get('OVERALL') : review.getIn(['ratings', RatingAxes.OVERALL]);
  return /*#__PURE__*/_jsx(View, {
    borderBlockEndStyle: "solid",
    borderColor: "border-core-default",
    borderWidth: "100",
    inlineSize: "100%",
    children: /*#__PURE__*/_jsxs(Grid, {
      paddingBlock: "800",
      children: [/*#__PURE__*/_jsx(GridItem, {
        size: {
          xs: 12,
          md: 5,
          lg: 4
        },
        children: /*#__PURE__*/_jsx(View, {
          inlineSize: "100%",
          marginBlockEnd: marginBlockEnd,
          children: /*#__PURE__*/_jsxs(Flex, {
            flexDirection: flexDirection,
            alignItems: "start",
            justifyContent: "space-between",
            children: [/*#__PURE__*/_jsx(View, {
              marginBlockEnd: "800",
              as: "div",
              children: /*#__PURE__*/_jsx(ReviewerInfo, {
                review: review
              })
            }), /*#__PURE__*/_jsx(QualityDistribution, {
              qualityRatings: review.getQualityRatings(showOriginal),
              reviewType: ReviewTypes.APP
            })]
          })
        })
      }), /*#__PURE__*/_jsxs(GridItem, {
        size: {
          xs: 12,
          md: 7,
          lg: 8
        },
        children: [/*#__PURE__*/_jsx(Section, {
          children: /*#__PURE__*/_jsx(Rating, {
            direction: "column",
            label: /*#__PURE__*/_jsxs(List, {
              inline: true,
              use: "inline-divided",
              wrapChildren: true,
              children: [/*#__PURE__*/_jsx(FormattedDateTime, {
                value: review.get('createdAt'),
                format: "ll",
                type: "userTz"
              }), review.get('lastEditedAt') && /*#__PURE__*/_jsxs("span", {
                children: [/*#__PURE__*/_jsx(View, {
                  as: "span",
                  marginInlineEnd: "100",
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "appMarketplace.detail.reviews.edit.edited"
                  })
                }), /*#__PURE__*/_jsx(FormattedDateTime, {
                  value: review.get('lastEditedAt'),
                  format: "ll",
                  type: "userTz"
                })]
              })]
            }),
            rating: rating,
            showTextRating: true
          })
        }), /*#__PURE__*/_jsx(ReviewBody, {
          review: review,
          searchTerm: searchTerm,
          showOriginal: showOriginal,
          showUntranslatedText: showUntranslatedText,
          onTrackInteraction: onTrackInteraction
        }), reviewActionsList, /*#__PURE__*/_jsx(ReviewReplyThread, {
          reply: review.getReply(showUntranslatedText),
          onReportReplyClick: isCustomer ? onReplyModalOpen : undefined
        }), reviewModalOpen && reportReviewModal, replyModalOpen && reportReplyModal]
      })]
    })
  });
}
export default withReportModalState(AllReviewsRenderer);